import { Easing } from 'react-native-reanimated';

export const durations = {
  instant: 90,
  fast: 170,
  normal: 280,
  slow: 420,
  entrance: 620,
  countUp: 900,
} as const;

export type DurationName = keyof typeof durations;

export const easings = {
  spring: Easing.bezier(0.22, 1, 0.36, 1),
  out: Easing.bezier(0.16, 1, 0.3, 1),
  inOut: Easing.bezier(0.65, 0, 0.35, 1),
  exit: Easing.bezier(0.4, 0, 1, 1),
  outExpo: Easing.bezier(0.19, 1, 0.22, 1),
} as const;

export type EasingName = keyof typeof easings;

export const easingCss = {
  spring: 'cubic-bezier(0.22, 1, 0.36, 1)',
  out: 'cubic-bezier(0.16, 1, 0.3, 1)',
  inOut: 'cubic-bezier(0.65, 0, 0.35, 1)',
  exit: 'cubic-bezier(0.4, 0, 1, 1)',
  outExpo: 'cubic-bezier(0.19, 1, 0.22, 1)',
} as const;

export const springs = {
  press: { damping: 14, stiffness: 240, mass: 0.6 },
  card: { damping: 18, stiffness: 180, mass: 0.9 },
  drawer: { damping: 22, stiffness: 140, mass: 1 },
} as const;

export type SpringName = keyof typeof springs;

// Sections and list items enter in sequence, top to bottom. The system
// specifies 60-80ms between items; 70 is what the per-screen rules call for.
export const stagger = {
  baseDelay: 80,
  step: 70,
  delay: (index: number, baseDelay = 80, step = 70): number => baseDelay + index * step,
} as const;

export const motion = {
  durations,
  easings,
  easingCss,
  springs,
  stagger,
} as const;

export type Motion = typeof motion;
